import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import Config from 'config'
import registerServiceWorker, { unregister as unregisterServiceWorker } from 'utils/registerServiceWorker'

import './lang/i18n'

ReactDOM.render(<App />, document.getElementById('root'))

if (Config.useServiceWorker) {
    registerServiceWorker()
} else {
    unregisterServiceWorker()
}



// WEBPACK FOOTER //
// src/index.js